module.exports = __webpack_public_path__ + "static/media/page2_deer.937bc38d.png";